import React from 'react'
import ReactDOM from 'react-dom'

export default class ReturnItem extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.selectItem = this.selectItem.bind(this)
    this.onSelectReason = this.onSelectReason.bind(this)
    this.renderOption = this.renderOption.bind(this)
    this.state = { reason: this.props.reason}
  }

  selectItem() {
    this.props.selectItem(this.props.item, this.state.reason)
  }

  onSelectReason(event) {
    this.setState({reason: event.target.value})
    if (!this.props.selected || this.props.reason != event.target.value) {
      this.props.selectItem(this.props.item, event.target.value)
    }
  }

  renderOption(reason) {
    var reasonText = 'reasons.' + reason + ".label"
    return (
      <option key={reason} value={reason}>
        {I18n.t(reasonText)}
      </option>
    )
  }

  render() {
    return (
      <div className="row item" >
        <div className="col-5 col-sm-4">
          <div className="product" onClick={this.selectItem}>
              <div className={this.props.selected != "" ? "overlay" : ""}></div>
              <i className={this.props.selected != "" ? "fa fa-check" : ""} />
              <img src={this.props.item.product.picture_url} className="img-fluid" alt={this.props.item.label} />
          </div>
        </div>
        <div className="col-7 col-sm-8">
          <div className="row">
            <div className="col-12 col-md-7 details">
              <p className="label">{this.props.item.label}</p>
              <ul>
                { this.props.item.reference != null ?
                    <li>
                      <label>Reference</label>
                      <span>{this.props.item.reference}</span>
                    </li>
                    :
                    <li></li>
                }
                { this.props.item.brand != null ?
                    <li>
                      <label>Brand</label>
                      <span>{this.props.item.product.brand}</span>
                    </li>
                    :
                    <li></li>
                }
              </ul>
            </div>
            <div className="col-12 col-md-5">
              <select className="custom-select" onChange={this.onSelectReason} defaultValue={this.state.reason ? this.state.reason : ""}>
                <option key="default" value="not_returned">{I18n.t('shipbacks.items.items.not_returned')}</option>
              {
                this.props.reasons.map((reason) => (
                  this.renderOption(reason)
                ))
              }
              </select>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/components/ReturnItem.jsx